/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/restrict-template-expressions */
/* eslint-disable @typescript-eslint/strict-boolean-expressions */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Divider, Typography, IconButton } from '@mui/material';
import React, { useEffect, useState } from 'react'
import OutlineButton from '../../MUICustomButton/OutlineButton';

import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import { styled } from '@mui/material/styles';
import { UPDATE_CLIENT_ACTIVATE_SUBTITLE_1, UPDATE_CLIENT_DEACTIVATE_SUBTITLE_1, UPDATE_CLIENT_DEACTIVATE_SUBTITLE_2 } from 'src/constants/constant';
import GradientButton from '../../MUICustomButton/GradientButton';
import type { ClientStatusObj, RootState } from '../../types/types';
import { getClientDetailsById, changeStatusClientData } from 'src/services/emailAPIClientServices';
import { getESPConnectionDataById } from 'src/services/emailAPIESPServices';
import { useSelector } from 'react-redux';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { NotificationManager } from 'react-notifications';
//@ts-ignore
import { HugeiconsIcon } from '@hugeicons/react';
//@ts-ignore
import {MultiplicationSignStrokeStandard} from '@hugeicons-pro/core-stroke-standard';
import EditClientForm from './EditClientForm';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));


export interface PropsType {
    clientId?: string;
    clientData?: any;
}

function ClientDetailsPage({ clientId, clientData }: PropsType): JSX.Element {

    const [showDeactivateClientModal, setShowDeactivateclientModal] = useState<boolean>(false)
    const [isModalSaveLoading, setIsModalSaveLoading] = useState<boolean>(false)
    const [isDataLoading, setIsDataLoading] = useState<boolean>(false)
    const [selectedClientData, setSelectedClientData] = useState<any>()
    const [espConnectionData, setESPConnectionData] = useState<any>()

    const [showClientInformationForm, setShowClientInformationForm] = useState<boolean>(false)
    const [showEmailConfiguratonForm, setEmailConfigurationForm] = useState<boolean>(false)

    const { user } = useSelector((state: RootState) => state.auth);

    useEffect(() => {
        getClientDetails()
    }, [clientId, clientData])

    const getClientDetails = (): void => {
        setIsDataLoading(true)
        if (clientId) {
            getClientDetailsById(clientId).then(
                (res: any) => {
                    if (res.status === 200) {
                        if (res.data.result === 1) {
                            setSelectedClientData(res.data.data[0])
                            getESPConnectionDataById(res.data.data[0].espConnectionId).then(
                                (res: any) => {
                                    if (res.status === 200) {
                                        if (res.data.result === 1) {
                                            setESPConnectionData(res.data.data[0])
                                        }
                                    }
                                }
                            )
                            .catch(
                                (error) => console.log(error)
                            )
                        }

                    }
                }
            )
            .catch(
                error => console.log("Error: ", error)
            )
            .finally(() => {
                setIsDataLoading(false)
            })
        }
    }

    const handleEditClientClick = (): void => {
        setShowClientInformationForm(true)
        setEmailConfigurationForm(false)
    }

    const handleEditEmailClick = (): void => {
        setEmailConfigurationForm(true)
        setShowClientInformationForm(false)
    }

    const handleStatusChange = (): void => {
        setShowDeactivateclientModal(true)
    }

    const handleDeactivateClientClose = (): void => {
        setShowDeactivateclientModal(false)
    }

    const handleCancelClick = (): void => {
        setShowClientInformationForm(false)
        setEmailConfigurationForm(false)
        getClientDetails()
    }

    const handleDeactivateClientConfirm = async (): Promise<void> => {
        setIsModalSaveLoading(true)
        const data: ClientStatusObj = {
            "modifiedBy": user?.id,
            "isActive": clientData?.isActive === true ? false : true,
            "clientLst": [
                {
                    "id": clientData?.id
                }
            ]
        }
        try {
            const res = await changeStatusClientData(data);

            if (res.status === 200) {
                if (res.data.result === 1) {
                    NotificationManager.success(
                        ((clientData?.isActive) === true)
                            ? "Client deactivated successfully"
                            : "Client activated successfully"
                    );
                    clientData.isActive = clientData?.isActive === true ? false : true
                    //   getClientData();
                }
            }
        } catch (error) {
            console.error("Error activating/deactivating client:", error);
            NotificationManager.error("An error occurred. Please try again.");
        } finally {
            setShowDeactivateclientModal(false);
            setIsModalSaveLoading(false);
        }
    }
    return (
        <React.Fragment>
            <div className="flex justify-between items-center mb-[20px]">
                <Typography variant="h6" gutterBottom sx={{ color: '#3A3A3A', fontSize: '16px', fontWeight: '600', marginBottom: '10px' }}>
                    Profile
                </Typography>
                <OutlineButton onClick={handleStatusChange} type='rounded' color='red' width='130px'>
                    {clientData.isActive ? 'Deactivate' : 'Activate'}
                </OutlineButton>
            </div>
            <Divider sx={{ color: '#D9D9D9', marginBottom: '10px' }} />
            {
                isDataLoading ? <div className='flex justify-center items-center relative top-[50%]'><span className="loading loading-spinner text-primary"></span></div> :

                    <React.Fragment>
                        <div className='form-sub-container'>
                            <div className='flex justify-between items-center'>
                                <Typography variant="h6" gutterBottom sx={{ color: '#3A3A3A', fontSize: '16px', fontWeight: '600', marginBottom: '20px' }}>
                                    Client Information
                                </Typography>
                                {
                                    showClientInformationForm === false &&
                                    <OutlineButton color='gray' onClick={() => handleEditClientClick()} width='80px'>
                                        <img src={'/assets/images/icons/EditIcon.svg'} width={15} height={15} alt="" style={{ marginRight: '10px' }} /> Edit
                                    </OutlineButton>
                                }

                            </div>
                            {
                                <React.Fragment>
                                    {
                                        showClientInformationForm === true ?
                                            <EditClientForm clientId={clientId} clientData={selectedClientData} step="1" onCancel={handleCancelClick} /> :

                                            <React.Fragment>
                                                <div className='grid gap-5 grid-cols-2'>
                                                    <div className='w-full relative'>
                                                        <Typography variant="h6" gutterBottom sx={{ color: '#3A3A3A', fontSize: '14px', fontWeight: '600', marginBottom: '10px' }}>
                                                            Client Name
                                                        </Typography>
                                                        <Typography sx={{ color: '#3A3A3A', fontSize: '14px', marginBottom: '20px' }}>
                                                            {selectedClientData?.clientName}
                                                        </Typography>
                                                    </div>
                                                </div>
                                                <div className='grid gap-5 grid-cols-2'>
                                                    <div className='w-full relative'>
                                                        <Typography variant="h6" gutterBottom sx={{ color: '#3A3A3A', fontSize: '14px', fontWeight: '600', marginBottom: '10px' }}>
                                                            Client Contact
                                                        </Typography>
                                                        <Typography sx={{ color: '#3A3A3A', fontSize: '14px', marginBottom: '20px' }}>
                                                            {selectedClientData?.clientContact ? selectedClientData.clientContact : ''}
                                                        </Typography>
                                                    </div>
                                                </div>
                                                <div className='grid gap-5 grid-cols-2'>
                                                    <div className='w-full relative'>
                                                        <Typography variant="h6" gutterBottom sx={{ color: '#3A3A3A', fontSize: '14px', fontWeight: '600', marginBottom: '10px' }}>
                                                            Client Email Address
                                                        </Typography>
                                                        <Typography sx={{ color: '#3A3A3A', fontSize: '14px', marginBottom: '20px' }}>
                                                            {selectedClientData?.email ? selectedClientData.email : ''}
                                                        </Typography>
                                                    </div>
                                                </div>
                                            </React.Fragment>
                                    }
                                </React.Fragment>
                            }

                        </div>

                        <div className='form-sub-container'>
                            <div className='flex justify-between items-center'>
                                <Typography variant="h6" gutterBottom sx={{ color: '#3A3A3A', fontSize: '16px', fontWeight: '600', marginBottom: '20px' }}>
                                    Email Configuration
                                </Typography>
                                {
                                    showEmailConfiguratonForm === false &&
                                    <OutlineButton color='gray' onClick={() => handleEditEmailClick()} width='80px'>
                                        <img src={'/assets/images/icons/EditIcon.svg'} width={15} height={15} alt="" style={{ marginRight: '10px' }} /> Edit
                                    </OutlineButton>
                                }
                            </div>

                            {
                                showEmailConfiguratonForm === true ?
                                    <EditClientForm clientId={clientId} clientData={selectedClientData} step="2" onCancel={handleCancelClick} /> :
                                    <React.Fragment>

                                        <div className='grid gap-5 grid-cols-2'>
                                            <div className='w-full relative'>
                                                <Typography variant="h6" gutterBottom sx={{ color: '#3A3A3A', fontSize: '14px', fontWeight: '600', marginBottom: '10px' }}>
                                                    Domain Name
                                                </Typography>
                                                <Typography sx={{ color: '#3A3A3A', fontSize: '14px', marginBottom: '20px' }}>
                                                    {espConnectionData?.domain}
                                                </Typography>
                                            </div>
                                            <div className='w-full relative'>
                                                <Typography variant="h6" gutterBottom sx={{ color: '#3A3A3A', fontSize: '14px', fontWeight: '600', marginBottom: '10px' }}>
                                                    Email Service Provider (ESP)
                                                </Typography>
                                                <Typography sx={{ color: '#3A3A3A', fontSize: '14px', marginBottom: '20px' }}>
                                                    {espConnectionData?.connectionName}
                                                </Typography>
                                            </div>
                                        </div>
                                        <div className='grid gap-5 grid-cols-2'>
                                            <div className='w-full relative'>
                                                <Typography variant="h6" gutterBottom sx={{ color: '#3A3A3A', fontSize: '14px', fontWeight: '600', marginBottom: '10px' }}>
                                                    From Email Name
                                                </Typography>
                                                <Typography sx={{ color: '#3A3A3A', fontSize: '14px', marginBottom: '20px' }}>
                                                    {espConnectionData?.fromName}
                                                </Typography>
                                            </div>
                                            <div className='w-full relative'>
                                                <Typography variant="h6" gutterBottom sx={{ color: '#3A3A3A', fontSize: '14px', fontWeight: '600', marginBottom: '10px' }}>
                                                    From Email Address
                                                </Typography>
                                                <Typography sx={{ color: '#3A3A3A', fontSize: '14px', marginBottom: '20px' }}>
                                                    {espConnectionData?.fromEmail}
                                                </Typography>
                                            </div>
                                        </div>
                                    </React.Fragment>
                            }
                        </div>
                    </React.Fragment>
            }


            <BootstrapDialog
                onClose={handleDeactivateClientClose}
                aria-labelledby="customized-dialog-title"
                open={showDeactivateClientModal}
                PaperProps={{
                    sx: {
                        width: '550px',
                        height: '200px'
                    },
                }}
            >
                <DialogTitle sx={{ m: 0, p: 2, color: '#3A3A3A', fontSize: '18px', fontWeight: '600' }} id="customized-dialog-title">
                    {clientData && clientData.isActive === true ? "Deactivate Client" : "Activate Client"}
                </DialogTitle>
                <IconButton
                    aria-label="close"
                    onClick={handleDeactivateClientClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <HugeiconsIcon
                     icon={MultiplicationSignStrokeStandard}
                     size={24}
                     color="currentcolor"
                     strokeWidth={0.5}
                                                     /> 
                </IconButton>
                <DialogContent>
                    {
                        clientData !== undefined && clientData.isActive === true ?
                            <p className='text-14 text-muted'>{UPDATE_CLIENT_DEACTIVATE_SUBTITLE_1} <span className='font-semibold'>{`${selectedClientData !== undefined ? selectedClientData.clientName : ''} `}</span> {UPDATE_CLIENT_DEACTIVATE_SUBTITLE_2}</p>
                            :
                            <p className='text-14 text-muted'>{UPDATE_CLIENT_ACTIVATE_SUBTITLE_1} <span className='font-semibold'>{`${selectedClientData !== undefined ? selectedClientData.clientName : ''}`}</span> {UPDATE_CLIENT_DEACTIVATE_SUBTITLE_2}</p>
                    }

                </DialogContent>
                <DialogActions sx={{ background: '#F9F9F9' }}>
                    <OutlineButton color='gray' onClick={handleDeactivateClientClose} width='130px'>Cancel</OutlineButton>
                    {/* <Button btntype="submit" label={!isModalSaveLoading ? "Delete" : <span className="loading loading-spinner loading-xs text-white"></span>} isGradient={true} color={"primary"} size={"small"} onClick={handleDeleteUserConfirm} disabled={isModalSaveLoading}></Button> */}
                    <GradientButton color='red' onClick={() => {
                        void handleDeactivateClientConfirm();
                    }} width='130px'>{
                            isModalSaveLoading ? (
                                <span className="loading loading-spinner loading-xs text-white"></span>
                            ) : ((clientData?.isActive) === true) ? "Deactivate" : "Activate"
                        }</GradientButton>
                </DialogActions>
            </BootstrapDialog>
        </React.Fragment>
    )
}

export default ClientDetailsPage